export * from "./gen/types.gen.js"
export { createSseClient } from "./gen/core/serverSentEvents.gen.js"

import { createClient } from "./gen/client/client.gen.js"
import { type Config } from "./gen/client/types.gen.js"
import { MuxClient } from "./gen/sdk.gen.js"
export { type Config as MuxClientConfig, MuxClient }

import { transportFetch } from "@/transport/http"
import { workspaceHeaders } from "./workspace.js"

export function createMuxClient(config?: Config & { directory?: string; workspaceID?: string }) {
  if (!config?.fetch) {
    const customFetch: typeof fetch = (input, init) => {
      if (input instanceof Request) Object.assign(input, { timeout: false })
      return transportFetch(input, init)
    }
    config = {
      ...config,
      fetch: customFetch,
    }
  }

  const headers = workspaceHeaders(config?.directory, config?.workspaceID)
  if (Object.keys(headers).length > 0) {
    config.headers = {
      ...config.headers,
      ...headers,
    }
  }

  const client = createClient(config)
  return new MuxClient({ client })
}
